import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'user';
const LOGIN_PATH = '/users/login';
const REGISTER_TOKEN_PATH = '/users/me/token';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {

    authenticationState = new BehaviorSubject(false);

    constructor() {

    }

}
